import router from '@/router/index'
const routeList = {
	state:{
		routeArr:[],
		isfirst:'',
	},
	mutations:{
		ADDROUTECHILD:(state,menu)=>{
			function childComponentHander(path) {
				return resolve=> require(["@/pages/" + path],resolve)
			}
			const components = require.context('@/pages',true,/\.vue$/);
			state.routeArr.splice(0);
			let datas = []
			if(menu) {
				menu.forEach(item=>{
					if(item.children.length==0){
						if(datas.indexOf(item)==-1){
							datas.push({
								meta:{
									label: item.name,
									title: item.href,
									keepAlive: true,
								},
								name:item.name,
								path:item.href,
							});
						}
					}else {
						item.children.forEach(i=>{
							if(datas.indexOf(i)==-1){
								datas.push({
									meta:{
										label: i.name,
										title: i.href,
										keepAlive: true,
									},
									name:i.name,
									path:i.href,
								});
							}
						})
					}
				})
			};
			components.keys().forEach(n=>{
				if( n== './login.vue' || n== './index.vue' || n == './personalSettings.vue'){
					return true;
				}
				let fileName = n.slice(n.lastIndexOf('/')).replace(/\.vue$/,"");
				let view = "pages" + n.slice(1);
				datas.forEach((item,index)=>{
					if(item.path == fileName){
						state.routeArr.push({
							meta:{
								label: item.name,
								title: (item.path).slice(1),
								keepAlive: true,
							},
							name:item.name,
							path:item.path,
							component:  resolve=> require(['@/'+view],resolve),
						})
					}
				})
			});
			// let  excessData = [
			// 		{
			// 			path: '/personalSettings',
			// 			name: 'PersonalSettings',
			// 			component: resolve=> require(['@/pages/personalSettings'],resolve),
			// 			meta: {
			// 				label: '个人设置',
			// 				title: 'personalSettings',
			// 				keepAlive: true,
			// 			}
			// 		},{
			// 			path: '/extraData',
			// 			name: 'ExtraData',
			// 			component: resolve=> require(['@/pages/reportForm/extraData'],resolve),
			// 			meta: {
			// 				label: '表外数据',
			// 				title: 'extraData',
			// 				keepAlive: true,
			// 			}
			// 		}
			// ]
			// if(excessData.length) {
			// 	excessData.forEach(i=>{
			// 		state.routeArr.push(i);
			// 	})
			// }
			router.addRoutes([{
					path: '',
					component: resolve=> require(['@/pages/index'],resolve) ,
					redirect: 'home',
					children:[
						...state.routeArr,
						{
							path: '/personalSettings',
							name: 'personalSettings',
							component: resolve=> require(['@/pages/personalSettings'],resolve),
							meta: {
								label: '个人设置',
								title: 'personalSettings',
								keepAlive: true,
							}
						},{
							path: '/extraData',
							name: 'extraData',
							component: resolve=> require(['@/pages/reportForm/extraData'],resolve),
							meta: {
								label: '表外数据',
								title: 'extraData',
								keepAlive: true,
							}
						},
						{
							path: '/error',
							name: 'error',
							component: resolve=> require(['@/pages/error'],resolve),
							meta: {
								label: '页面错误',
								title: 'error',
								keepAlive: true,
							}
						},
					]
				}
			]);
		},
		IS_FIRST_LOGIN(state,view) {
			state.isfirst = view;
			sessionStorage.setItem('isfirst' , view)
		},
		CLEARROUTER:(state)=>{
			state.routeArr.splice(0);
		}
	}
};

export default routeList



// WEBPACK FOOTER //
// ./src/store/modules/routeList.js